/* eslint max-classes-per-file: 0 */

import {
  LkUser as Data,
  LkUserCollection as Collection,
} from '@/typings/api/User'
import { LkUsersApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class ProfileLKTransformerParams extends TransformerParams {
}

export class LKProfilesAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new ProfileLKTransformerParams();
}
